import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import { resultSuccess } from '../utils';

export default defineFakeRoute([
  {
    url: '/o-apis-example/mock/app/web/user/info',
    timeout: 200,
    method: 'get',
    response: () => {
      return resultSuccess({
        empCode: '01406089',
        empName: '李振',
      });
    },
  },
]);
